module.exports = __webpack_public_path__ + "img/626.ce059ccc.png";